import { render } from "./TitleSeparator.vue?vue&type=template&id=688a042d&scoped=true"
import script from "./TitleSeparator.vue?vue&type=script&lang=js"
export * from "./TitleSeparator.vue?vue&type=script&lang=js"

import "./TitleSeparator.vue?vue&type=style&index=0&id=688a042d&scoped=true&lang=scss"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-688a042d"]])

export default __exports__